import React from 'react';

import s from './DownloadSlide.module.scss';
import getAssetLink from '../../../util/getAssetLink';
import { APP_STORE_LINK, PLAY_STORE_LINK } from '../../WebFooter';

class DownloadSlide extends React.Component {
  render() {
    return (
      <div className={s.downloadSlideContainer}>
        <div className={s.downloadSlideContent}>
          <div className={s.largeText}>
            EINFACH SWIPEN.
            <br />
            INTERESSEN ENTDECKEN.
            <br />
            BERUFE FINDEN.
          </div>
          <div className={s.downloadSectionWrapper}>
            <h2>Lade die App herunter</h2>
            <div className={s.text}>
              Jopsy ist kostenlos im App Store
              <br />
              und in Google Play erhätlich.
            </div>
            <div className={s.downloadSection}>
              <img
                className={s.icon}
                src={getAssetLink('icon_small.png')}
                alt="Jopsy"
              />
              <div className={s.downloadButtons}>
                <a
                  href={PLAY_STORE_LINK}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Zum Play Store"
                >
                  <img src={getAssetLink('playStore.png')} alt="Play Store" />
                </a>
                <a
                  href={APP_STORE_LINK}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Zum App Store"
                >
                  <img src={getAssetLink('appStore.png')} alt="App Store" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DownloadSlide;
